import { createStore } from 'vuex'

/**
 合约对象
 window.betsabi
 window.bankabi
 window.usdtabi
 */

export default createStore({
  state: {
    DefaultNetwork: '1', // 默认网络 : 1
    TestNetwork: '421614', // 默认测试网络Arbitrum Sepolia:421614
    MyReferrer: '', // 我的推荐人
    RoutePage:'',
    phone:{isPhone:false,orientation:''},// 系统启动时检查当前设备是否为手机，orientation：portrait-primary 竖屏, landscape-primary横屏
    DialogShow: false, // 无交互对话框
    dialog:{title:'warning',text1:'',text2:'',text3:''},
    ConfirmDialogShow: false, // 含确定和取消按钮的对话框
    ConfirmDialog:{title:'warning', confirm:false, text1:'',text2:'',text3:''},
    color:{purple: '#D610D8', blue: '#14FDFF'}, // purple-accent-3 亮紫色 以web色为准确, cyan-accent-3 亮蓝色
    Snackbar: {type: 'success', show: false, text: 'ok'}, // 用于显示 公用提示信息 type=[info,success,warning,error]

    // 用户钱包登录的链 根据用户登录不同的链选择不同合约(getChainInfo)
    wallet:{
      chain:'',
      account:'',
      balance:{
        eth:'0',
        usdt:'0'
      }
    },
    // 线包所选当前链，当用来判断是否有合约部署
    // 如果是效链则在common.setChainInfo中设置合约数据，无效链则设空，有效链参考ValidChain
    chain:{
      Type: '', // 测试网Test,主网Main
      ID: '',
      Name: '',
      USDT: '',
      Trading: ''
    },

    // 失误部署v3在arbitrum one
    // ID:'42161',
    // Name:'Arbitrum one',
    // USDT:'0xF6C16Efb89cc91E8d2fcDc6a314f813A53CF7DdC',
    // Trading:'0x358c16dbe978574d7b51e628609b362dec39a5d9'
    // 已部署合约有效的链ID，用于检查当前链是否有效
    ValidChain:[
      {
        Type:'Test',
        ID:'421614',
        Name:'Arbitrum Sepolia',
        USDT:'0xE5c11B6a7B2733bb06d2BCE92f5222bc3E0a9489',
        Trading:'0x24256C4aFF215150BBFd39Bae2A22B5FB097bFA3'
      }
    ],
    ZeroAddress: '0x0000000000000000000000000000000000000000',
    gasDef:{gasPrice:1000000000, low:800000, middle:5373235, high:78467725},
    approveTotal: '9000000000000000000000000000', // 一次批准大数量避免多次批准
    faucet:{
      address: '0x5cB8629504F3F79b0E2c935e68e6976B5239a9c1', // 发放帐号
      key: 'b7dc8ba499b75c2e20ae4cdb8425ac6bcae859218127d31921dbba1b7d620cd1',
      usdtAmount: '2000000000', // 2000 d6 发放币种数量
      ethAmount: '20000000000000000', // 0.02 发放币种数量
    },
    SubscribeTicker: false,// 是否已订阅行情价格，获得实时价格，（如果已订阅不需要重复订阅）
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
